import React, { createContext, useState, ReactNode } from 'react';

export interface AccountInfo {
  accountName: string;
  accountNumber: string;
  balance: number;
  currency: string;
  core: string;
}

export interface Beneficiary {
  receiverId: string;
  receiverFirstName: string;
  receiverLastName: string;
  receiverAccountNumber: string;
  receiverBank: string;
  receiverCurrency: string;
  receiverEmail: string;
  receiverCountry: string;
}

interface MoveMoneyState {
  transactionId: string;
  setTransactionId: (id: string) => void;

  beneficiary: string;
  setBeneficiary: (beneficiary: string) => void;

  amount: string;
  setAmount: (amount: string) => void;

  fromAccount: string;
  setFromAccount: (fromAccount: string) => void;

  paymentMethod: string;
  setPaymentMethod: (paymentMethod: string) => void;

  paymentMethodResponse: any;
  setPaymentMethodResponse: (response: any) => void;

  accounts: AccountInfo[];
  setAccounts: (accounts: AccountInfo[]) => void;

  beneficiaries: Beneficiary[];
  setBeneficiaries: (beneficiaries: Beneficiary[]) => void;

  eventMapInstanceID: string;
  setEventMapInstanceID: (id: string) => void;

  sourceInstanceID: string;
  setSourceInstanceID: (id: string) => void;
}

export const MoveMoneyContext = createContext<MoveMoneyState | undefined>(undefined);

interface MoveMoneyProviderProps {
  children: ReactNode;
}

export const MoveMoneyProvider = ({ children }: MoveMoneyProviderProps) => {
  const [transactionId, setTransactionId] = useState('');
  const [beneficiary, setBeneficiary] = useState('');
  const [amount, setAmount] = useState('');
  const [fromAccount, setFromAccount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentMethodResponse, setPaymentMethodResponse] = useState(null);

  const [accounts, setAccounts] = useState<AccountInfo[]>([]);
  const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>([]);
  const [eventMapInstanceID, setEventMapInstanceID] = useState('');
  const [sourceInstanceID, setSourceInstanceID] = useState('');

  return (
    <MoveMoneyContext.Provider
      value={{
        transactionId,
        setTransactionId,
        beneficiary,
        setBeneficiary,
        amount,
        setAmount,
        fromAccount,
        setFromAccount,
        paymentMethod,
        setPaymentMethod,
        paymentMethodResponse,
        setPaymentMethodResponse,
        accounts,
        setAccounts,
        beneficiaries,
        setBeneficiaries,
        eventMapInstanceID,
        setEventMapInstanceID,
        sourceInstanceID,
        setSourceInstanceID,
      }}
    >
      {children}
    </MoveMoneyContext.Provider>
  );
};
